import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { WidgetStore } from '@markant-platform/widgets/data-access';

@Component({
  selector: 'markant-platform-organization-complete-profile-button',
  standalone: true,
  imports: [MarkantElementsModule, TranslocoModule],
  templateUrl: './organization-complete-profile-button.component.html',
  styleUrl: './organization-complete-profile-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationCompleteProfileButtonComponent implements OnInit {
  protected readonly store = inject(WidgetStore);
  @Input() variantId!: string;
  @Input() isFurtherQualificationProcessInProgress!: boolean;

  completeProfileButtonId = '';

  openCompleteProfileDialogVisibility(): void {
    this.store.toggleCompleteProfileDialogWidget(true);
  }

  ngOnInit(): void {
    this.completeProfileButtonId = `complete-profile-button-${this.variantId}`;
  }
}
